import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-industrial-training',
  templateUrl: './industrial-training.component.html',
  styleUrls: ['./industrial-training.component.scss']
})
export class IndustrialTrainingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
